/* Rheinkauf – Bestellstatus, Rücksendung, Widerruf und „Benachrichtigen, wenn wieder da“ (Paket A).
   Spricht mit dem Rheinkauf-Worker (Cloudflare, workers/rk-new/worker.js), gleiche API wie WSTND:
     GET  /api/health                         Version – fehlt beim alten Worker (404)
     GET  /api/track?no=&email=&lang=de[&scope=return]
     POST /api/returns                        Rücksendung anlegen
     POST /api/withdrawals                    Widerrufsfunktion nach § 356a BGB
     POST /api/notify                         Benachrichtigen, wenn wieder lieferbar
   Feste Angaben (Worker-Adresse, Kontakt-E-Mail, Rücksendeadresse, Labelpreis) stehen an genau einer
   Stelle: snippets/rk-api.liquid. Sie kommen als data-rk-api, data-rk-mail, data-rk-adresse und
   data-rk-label-preis an den Block. Der Worker liefert nur Codes, Zahlen und Zeiten – jeder Satz,
   den Kunden sehen, steht in dieser Datei. Nie rohe Codes anzeigen.

   Seiten: templates/page.bestellung.json ([data-rk-track]), templates/page.ruecksendung.json
   ([data-rk-return]), sections/rk-widerruf.liquid ([data-rk-widerruf]), Produktseite
   ([data-rk-notify], Block rk_notify in templates/product.json).

   Stand 05.10.2026: Stand WSTND (Retouren 30.09.) – Zeitlimits, Regeln je Lieferland und Labelpreis
   aus dem Worker, QR-Code sichtbar, Betrag und Rücksendeadresse aus der Worker-Antwort; Widerrufs-
   funktion mit Ersatzweg über das Kontaktformular; Fehlermeldungen per aria-describedby an den
   Feldern; „Benachrichtigen“ reagiert auf Ereignisse statt alle 800 ms zu prüfen. */
(function () {
  'use strict';

  var LANG = 'de';
  var ZONE = 'Europe/Berlin';
  /* Zeitlimits: Suche 15 s; Anlegen der Rücksendung 60 s – lieber länger warten, als den Kunden
     doppelt anmelden zu lassen. Widerruf 15 s, danach geht er über das Kontaktformular raus. */
  var T_SUCHE = 15000, T_ANLEGEN = 60000, T_WIDERRUF = 15000, T_HINWEIS = 15000, T_HEALTH = 6000;
  /* Zollgebiet der EU (wie EU_CUSTOMS im Worker). Aus allen anderen Ländern braucht die
     Rücksendung eine Zollinhaltserklärung. */
  var EU_ZOLL = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE',
    'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'MC'];
  /* Wie SLIP_TEXT.customs im Worker (steht auch auf dem Retourenschein). */
  var ZOLL_HINWEIS = 'Versand von außerhalb der EU: In der Zollinhaltserklärung (CN22/CN23) „Rücksendung / Returned goods“ als Grund angeben und eine Rechnungskopie beilegen.';
  /* Beispiel-Bestellnummer – kommt aus snippets/rk-api.liquid (data-rk-beispiel), hier nur Rückfall. */
  var BEISPIEL = 'EU-9112341';
  function beispielLesen(root) {
    var b = String(root.getAttribute('data-rk-beispiel') || '').trim();
    if (b) BEISPIEL = b;
  }
  var SEITE_KONTAKT = '/pages/beratung-und-kontakt';
  var SEITE_RETOURE = '/pages/ruecksendung';
  var SEITE_TRACKING = '/pages/bestellung-verfolgen';
  var SEITE_WIDERRUF = '/pages/widerruf';
  var ERKLAERUNG = 'Hiermit widerrufe ich den von mir abgeschlossenen Vertrag über den Kauf der Waren aus der oben genannten Bestellung.';

  /* ---------- Helfer ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function zeit(iso) {
    if (!iso) return null;
    var d = new Date(iso);
    return isNaN(d.getTime()) ? null : d;
  }
  /* Datum und Uhrzeit immer in deutscher Zeit – sonst verschiebt sich ein Scan für Kunden im Ausland. */
  function datum(iso) {
    var d = zeit(iso); if (!d) return '';
    try { return d.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric', timeZone: ZONE }); } catch (e) { return ''; }
  }
  function datumKurz(iso) {
    var d = zeit(iso); if (!d) return '';
    try { return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: ZONE }); } catch (e) { return ''; }
  }
  function datumZeit(iso) {
    var d = zeit(iso); if (!d) return '';
    try {
      return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', timeZone: ZONE }) + ', ' +
        d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: ZONE }) + ' Uhr';
    } catch (e) { return ''; }
  }
  /* „05.10.2026, 14:03:22 Uhr“ – wie der Eingangsstempel des Workers. */
  function stempel(d) {
    try {
      return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: ZONE }) + ', ' +
        d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, timeZone: ZONE }) + ' Uhr';
    } catch (e) { return d.toISOString(); }
  }
  /* „5,95 €“. Fehlt ein Betrag, leer statt „NaN €“. */
  function eur(n) {
    n = Number(n);
    return isFinite(n) ? n.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) : '';
  }
  function tage(n) { n = Number(n) || 0; return n === 1 ? '1 Tag' : n + ' Tage'; }
  function api(base, path) { return String(base || '').replace(/\/+$/, '') + path; }
  /* Links aus Antworten nur mit https – nie javascript: o. Ä. */
  function sicher(u) { return /^https:\/\//i.test(String(u || '')) ? String(u) : null; }
  /* Belege vom Worker (/api/file/<token>/<name>) gehören zur API-Domain. */
  function beleg(u, base) {
    u = String(u || '');
    if (base && /^\/api\/file\//.test(u)) return api(base, u);
    return sicher(u);
  }
  /* Bestellnummer aufräumen: Leerzeichen raus, Großbuchstaben, „#“ vorne weg. */
  function bestellNr(v) {
    v = String(v || '').replace(/\s+/g, '').toUpperCase();
    return v.charAt(0) === '#' ? v.slice(1) : v;
  }
  /* Dieselbe Prüfung wie validEmail() im Worker – sonst lehnt er ab, was die Seite durchgelassen hat. */
  function mailOk(s) {
    s = String(s || '').trim();
    return s.length >= 6 && s.length <= 254 && /^[^\s@]+@[^\s@,;:]+\.[a-z]{2,}$/i.test(s);
  }
  function liste(a) {
    a = (a || []).map(String);
    return a.length > 1 ? a.slice(0, -1).join(', ') + ' und ' + a[a.length - 1] : (a[0] || '');
  }
  function ruhig() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function nachOben(el) {
    if (!el || !el.scrollIntoView) return;
    try { el.scrollIntoView({ block: 'start', behavior: ruhig() ? 'auto' : 'smooth' }); } catch (e) { el.scrollIntoView(true); }
  }
  /* Fokus auf Überschrift oder Meldung – der geklickte Knopf ist nach dem Neuzeichnen oft weg. */
  function fokus(el, scrollen) {
    if (!el || !el.focus) return;
    if (!/^(A|BUTTON|INPUT|SELECT|TEXTAREA|FIELDSET)$/.test(el.tagName) && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    if (el.tagName === 'FIELDSET') { var erstes = el.querySelector('input'); if (erstes) el = erstes; }
    try { el.focus({ preventScroll: !scrollen }); } catch (e) { el.focus(); }
  }
  /* Kurze Ansage für Screenreader ([data-rk-status], role=status). */
  function ansage(root, text) {
    var s = $('[data-rk-status]', root);
    if (!s) return;
    s.textContent = '';
    setTimeout(function () { s.textContent = text || ''; }, 60);
  }
  function lesen(key) { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { return null; } }
  function merken(key, wert) { try { sessionStorage.setItem(key, JSON.stringify(wert)); } catch (e) {} }
  function abfrage(no, email) {
    if (!no && !email) return '';
    return '?no=' + encodeURIComponent(no || '') + (email ? '&email=' + encodeURIComponent(email) : '');
  }
  function kontaktLink(text) {
    return '<a class="rk-link" href="' + SEITE_KONTAKT + '">' + esc(text || 'Kontakt') + '</a>';
  }

  var ICON = {
    haken: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    paket: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5v-9Z M3.5 7.5 12 12l8.5-4.5 M12 12v9" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    lkw: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M2.5 6.5h11v9h-11z M13.5 9.5h4l3 3v3h-7 M6.5 18.5a1.7 1.7 0 1 0 0-.1 M17 18.5a1.7 1.7 0 1 0 0-.1" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    drucker: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.5 9V3.5h11V9 M6.5 17H4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2.5 M6.5 14h11v6.5h-11z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    doku: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 3h8l4 4v14H6z M14 3v4h4 M9 12h6 M9 16h6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    info: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M12 11v5.5 M12 7.6v.1" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    zurueck: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M9 14 4 9l5-5 M4 9h10.5a5.5 5.5 0 0 1 0 11H11" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* ---------- Fehlertexte ----------
     art: 'suche' (Bestellung suchen), 'retoure' (Rücksendung anlegen), 'hinweis' (Benachrichtigen),
          'widerruf'.
     Codes des Workers: not_found, rate_limited, not_delivered, window_expired, return_open,
     qty_invalid, reason_invalid, size_missing, too_many, disabled, bad_request, server_error;
     dazu network und timeout von hier. */
  function fehlerText(code, art) {
    switch (code) {
      case 'leer': return 'Bitte geben Sie Bestellnummer und E-Mail-Adresse ein. Beides steht in Ihrer Bestellbestätigung.';
      case 'leer_no': return 'Bitte geben Sie die Bestellnummer ein, z. B. ' + BEISPIEL + '. Sie steht in Ihrer Bestellbestätigung.';
      case 'leer_mail': return 'Bitte geben Sie die E-Mail-Adresse ein, mit der Sie bestellt haben.';
      case 'not_found':
        if (art === 'hinweis') return 'Diesen Artikel finden wir gerade nicht. Bitte laden Sie die Seite neu und versuchen Sie es noch einmal.';
        return 'Zu dieser Bestellnummer und E-Mail-Adresse finden wir keine Bestellung. Bitte prüfen Sie beide Angaben – so, wie sie in der Bestellbestätigung stehen. Haben Sie gerade erst bestellt? Dann versuchen Sie es in ein paar Minuten noch einmal.';
      case 'rate_limited':
        if (art === 'suche') return 'Zu viele Anfragen in kurzer Zeit. Bitte warten Sie eine Minute und versuchen Sie es dann noch einmal.';
        return 'Zu viele Versuche in kurzer Zeit. Bitte versuchen Sie es in einer Stunde noch einmal – oder schreiben Sie uns.';
      case 'not_delivered': return 'Die Bestellung ist noch nicht zugestellt. Eine Rücksendung können Sie anmelden, sobald das Paket bei Ihnen ist.';
      case 'window_expired': return 'Die Rückgabefrist für diese Bestellung ist abgelaufen. Bei einem Mangel gilt die gesetzliche Gewährleistung – bitte schreiben Sie uns.';
      case 'return_open': return 'Für diese Bestellung ist bereits eine Rücksendung angemeldet.';
      case 'qty_invalid':
        if (art === 'retoure') return 'Die Auswahl passt nicht zur Bestellung. Bitte laden Sie die Seite neu und wählen Sie die Artikel noch einmal aus.';
        return 'Bitte wählen Sie mindestens einen Artikel aus.';
      case 'reason_invalid': return 'Bitte wählen Sie für jeden ausgewählten Artikel einen Grund.';
      case 'size_missing': return 'Bitte prüfen Sie Ihre Auswahl.';
      case 'too_many': return 'Mit dieser E-Mail-Adresse sind schon sehr viele Artikel vorgemerkt. Mehr geht leider nicht.';
      case 'disabled':
        if (art === 'hinweis') return 'Die Benachrichtigung ist gerade nicht verfügbar. Bitte versuchen Sie es später noch einmal.';
        break;
      case 'bad_request':
        if (art === 'hinweis') return 'Bitte prüfen Sie die E-Mail-Adresse.';
        return 'Bitte prüfen Sie Ihre Angaben.';
      case 'email_leer': return 'Bitte geben Sie Ihre E-Mail-Adresse ein.';
      case 'email_bad': return 'Bitte prüfen Sie die E-Mail-Adresse, zum Beispiel auf Tippfehler.';
      case 'timeout': return 'Die Antwort dauert gerade zu lange. Bitte versuchen Sie es gleich noch einmal.';
      case 'langsam': return 'Das dauert gerade länger als sonst. Ihre Rücksendung wird vielleicht trotzdem angelegt. Bitte schauen Sie in ein paar Minuten in Ihr E-Mail-Postfach oder prüfen Sie hier den Stand, bevor Sie es noch einmal versuchen.';
      case 'network': return 'Wir erreichen unseren Server gerade nicht. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es gleich noch einmal.';
      case 'wd_name': return 'Bitte geben Sie Ihren Vor- und Nachnamen an.';
      case 'wd_order': return 'Bitte geben Sie die Bestellnummer an. Sie steht in Ihrer Bestellbestätigung, z. B. ' + BEISPIEL + '.';
      case 'wd_email': return 'Bitte geben Sie Ihre E-Mail-Adresse an. Dorthin schicken wir die Eingangsbestätigung.';
      case 'wd_check': return 'Bitte bestätigen Sie die Erklärung mit einem Haken.';
      case 'wd_abgelehnt': return 'Ihre Angaben wurden nicht angenommen. Bitte prüfen Sie Name, Bestellnummer und E-Mail-Adresse und senden Sie noch einmal. Oder schicken Sie den Widerruf über unser Kontaktformular.';
    }
    return 'Das hat gerade nicht geklappt. Bitte versuchen Sie es gleich noch einmal – oder schreiben Sie uns.';
  }

  /* ---------- Fehlermeldungen ----------
     Die Meldung steht in einem Kasten mit role="alert" (wird vorgelesen). Betrifft sie ein Feld,
     bekommt das Feld aria-invalid und verweist per aria-describedby auf die Meldung; der Fokus
     springt ins Feld. Sonst springt der Fokus auf die Meldung selbst. Wo die Meldung „schreiben Sie
     uns“ sagt, steht der Link zur Seite „Kontakt“ dabei. */
  var fehlerNr = 0;
  function verknuepfen(feld, id, an) {
    if (!feld || !id) return;
    var ids = String(feld.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (x) { return x && x !== id; });
    if (an) ids.push(id);
    if (ids.length) feld.setAttribute('aria-describedby', ids.join(' ')); else feld.removeAttribute('aria-describedby');
    if (an) {
      feld.setAttribute('aria-invalid', 'true');
      feld.setAttribute('data-rk-fehler-id', id);
    } else {
      feld.removeAttribute('aria-invalid');
      feld.removeAttribute('data-rk-fehler-id');
    }
  }
  function fehlerBox(text, zusatz, id) {
    if (!zusatz && /schreiben Sie uns/.test(text)) zusatz = '<p>' + kontaktLink('Zur Seite „Kontakt“') + '</p>';
    return '<div class="rk-fehler" role="alert" tabindex="-1"' + (id ? ' id="' + id + '"' : '') + '><span class="rk-fehler__icon">' + ICON.info + '</span>' +
      '<div class="rk-fehler__text"><p>' + esc(text) + '</p>' + (zusatz || '') + '</div></div>';
  }
  function fehlerWeg(ziel) {
    if (!ziel) return;
    var box = $('.rk-fehler', ziel);
    if (box && box.id) {
      $$('[data-rk-fehler-id="' + box.id + '"]').forEach(function (f) { verknuepfen(f, box.id, false); });
    }
    ziel.innerHTML = '';
  }
  function zeigeFehler(ziel, text, zusatz, felder) {
    if (!ziel) return;
    fehlerWeg(ziel);
    var id = 'rk-fehler-' + (++fehlerNr);
    ziel.innerHTML = fehlerBox(text, zusatz, id);
    felder = (felder ? [].concat(felder) : []).filter(Boolean);
    felder.forEach(function (f) { verknuepfen(f, id, true); });
    if (felder.length) fokus(felder[0], true); else fokus(ziel.firstChild, true);
  }
  /* Ändert der Kunde ein markiertes Feld, verschwindet die Markierung – und die Meldung, sobald
     kein Feld mehr auf sie verweist. */
  function feldBeobachten(form) {
    function weg(e) {
      var t = e.target;
      var el = t && t.closest ? t.closest('[data-rk-fehler-id]') : null;
      if (!el) return;
      var id = el.getAttribute('data-rk-fehler-id');
      verknuepfen(el, id, false);
      if (!document.querySelector('[data-rk-fehler-id="' + id + '"]')) {
        var box = document.getElementById(id);
        if (box && box.parentNode) box.parentNode.removeChild(box);
      }
    }
    form.addEventListener('input', weg);
    form.addEventListener('change', weg);
  }

  /* fetch mit Zeitlimit. Ergebnis immer { ok, status, data } oder { ok:false, status, error } –
     error ist der Code des Workers, sonst 'network', 'timeout' oder 'server_error'. */
  function holen(url, opts, ms) {
    opts = opts || {};
    return new Promise(function (fertig) {
      var ctl = window.AbortController ? new AbortController() : null;
      var vorbei = false;
      var uhr = setTimeout(function () {
        if (vorbei) return;
        vorbei = true;
        if (ctl) { try { ctl.abort(); } catch (e) {} }
        fertig({ ok: false, status: 0, error: 'timeout' });
      }, ms || T_SUCHE);
      function ende(r) { if (vorbei) return; vorbei = true; clearTimeout(uhr); fertig(r); }
      if (ctl) opts.signal = ctl.signal;
      var anfrage;
      try { anfrage = fetch(url, opts); } catch (e) { ende({ ok: false, status: 0, error: 'network' }); return; }
      anfrage.then(function (res) {
        return res.json().then(function (b) { return b; }, function () { return null; }).then(function (body) {
          if (res.ok && body) ende({ ok: true, status: res.status, data: body });
          else ende({ ok: false, status: res.status, error: (body && body.error) || (res.status === 404 ? 'not_found' : 'server_error'), data: body });
        });
      }, function () { ende({ ok: false, status: 0, error: 'network' }); });
    });
  }

  /* ---------- Suchformular (Bestellung verfolgen, Rücksendung) ---------- */
  /* Prüft Bestellnummer und E-Mail-Adresse. Gibt { no, email } zurück oder null (Fehler steht dann da). */
  function sucheLesen(form, root) {
    var feh = $('[data-rk-formfehler]', form);
    if (form.hidden) formularZeigen(root);
    var feldNo = form.elements.no, feldMail = form.elements.email;
    var no = bestellNr(feldNo.value);
    var email = String(feldMail.value || '').trim();
    if (!no && !email) { zeigeFehler(feh, fehlerText('leer'), '', [feldNo, feldMail]); return null; }
    if (!no) { zeigeFehler(feh, fehlerText('leer_no'), '', [feldNo]); return null; }
    if (!email) { zeigeFehler(feh, fehlerText('leer_mail'), '', [feldMail]); return null; }
    if (email.indexOf('@') < 1 || /\s/.test(email)) { zeigeFehler(feh, fehlerText('email_bad'), '', [feldMail]); return null; }
    fehlerWeg(feh);
    return { no: no, email: email };
  }

  /* Nach einem Treffer klappt das Formular zu einer Zeile zusammen. */
  function suchleiste(root, no, email) {
    var form = $('form', root);
    var bar = $('[data-rk-bar]', root);
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'rk-bar';
      bar.setAttribute('data-rk-bar', '');
      form.parentNode.insertBefore(bar, form.nextSibling);
    }
    bar.innerHTML = '<span class="rk-bar__icon">' + ICON.paket + '</span>' +
      '<span class="rk-bar__text"><strong>Bestellung ' + esc(no) + '</strong><span>' + esc(email) + '</span></span>' +
      '<button type="button" class="rk-bar__btn">Andere Bestellung</button>';
    bar.hidden = false;
    form.hidden = true;
    var intro = $('[data-rk-intro]', root); if (intro) intro.hidden = true;
    $('button', bar).onclick = function () {
      bar.hidden = true; form.hidden = false;
      if (intro) intro.hidden = false;
      $('[data-rk-out]', root).innerHTML = '';
      widerrufLink(root);
      schritt(root, 1);
      fokus(form.elements.no, true);
    };
  }
  function formularZeigen(root) {
    var form = $('form', root);
    if (form && form.hidden) {
      form.hidden = false;
      var bar = $('[data-rk-bar]', root); if (bar) bar.hidden = true;
      var intro = $('[data-rk-intro]', root); if (intro) intro.hidden = false;
    }
  }

  function schritt(root, n) {
    $$('[data-rk-schritt]', root).forEach(function (li) {
      var k = parseInt(li.getAttribute('data-rk-schritt'), 10);
      li.classList.toggle('is-fertig', k < n || (n === 4 && k === 4));
      li.classList.toggle('is-aktiv', k === n && n !== 4);
      if (k === n) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
    });
  }

  /* ---------- Texte für Status-Codes (Worker liefert nur Codes) ---------- */
  var STATUS = {
    storniert: ['Storniert', 'rk-st--grau'],
    bearbeitung: ['In Bearbeitung', 'rk-st--gelb'],
    unterwegs: ['Unterwegs', 'rk-st--blau'],
    teilweise: ['Teilweise versandt', 'rk-st--blau'],
    verzoegert: ['Verzögert', 'rk-st--orange'],
    zugestellt: ['Zugestellt', 'rk-st--gruen']
  };

  /* Überschrift zur Lieferprognose (eta.code aus buildEta im Worker), wie WSTND. Das Datum kommt
     vom Versender (DHL) oder aus Shopifys Schätzung – hier wird nichts dazuerfunden. */
  function etaText(eta, d) {
    if (!eta) return '';
    var tag = datum(eta.dueAt);
    var p = eta.packets || [];
    var sendungen = (d && d.shipments) || [];
    var mehrere = sendungen.length > 1;
    var schonDa = sendungen.some(function (s) { return s.state === 'zugestellt'; });
    switch (eta.code) {
      case 'cancelled': return 'Diese Bestellung wurde storniert';
      case 'delivered_one_at': return tag ? 'Zugestellt am ' + tag : 'Ihr Paket wurde zugestellt';
      case 'delivered_all_at': return tag ? 'Alle Pakete zugestellt, das letzte am ' + tag : 'Alle Pakete wurden zugestellt';
      case 'delivered_one': return 'Ihr Paket wurde zugestellt';
      case 'delivered_all': return 'Alle Pakete wurden zugestellt';
      case 'stuck_some':
        if (p.length > 1) return 'Die Pakete ' + liste(p) + ' sind verzögert';
        return p.length ? 'Paket ' + p[0] + ' ist verzögert' : 'Ein Paket ist verzögert';
      case 'stuck_all': return mehrere ? 'Ihre Pakete sind verzögert' : 'Ihre Sendung ist verzögert';
      case 'due_one': return tag ? 'Voraussichtlich am ' + tag + ' bei Ihnen' : 'Ihr Paket ist unterwegs';
      case 'due_first':
        if (!tag) return 'Ihre Pakete sind unterwegs';
        return (schonDa ? 'Das nächste Paket kommt voraussichtlich am ' : 'Das erste Paket kommt voraussichtlich am ') + tag;
      case 'ship_soon': return 'Ihre Bestellung ist in Bearbeitung';
      case 'deliver_soon': return mehrere ? 'Ihre Pakete sind unterwegs' : 'Ihr Paket ist unterwegs';
      default: return '';
    }
  }
  function etaZusatz(eta) {
    if (!eta) return '';
    switch (eta.code) {
      case 'stuck_some':
      case 'stuck_all': return 'Seit einigen Tagen gibt es vom Versender keine neue Meldung. Den letzten Stand sehen Sie unten. Haben Sie Fragen dazu? Dann schreiben Sie uns.';
      case 'due_first': return 'Die übrigen Pakete folgen – den Stand sehen Sie unten bei jedem Paket.';
      case 'ship_soon': return 'Sobald das Paket unterwegs ist, sehen Sie hier die Sendungsnummer und den Stand der Zustellung.';
      case 'deliver_soon': return 'Den aktuellen Stand sehen Sie unten bei der Sendung.';
      default: return '';
    }
  }

  /* Schritte der Sendung (Codes aus SCAN_RULES im Worker) und der Rücksendung. */
  var SCHRITT = {
    packed: 'Im Lager gepackt',
    handover: 'An {carrier} übergeben',
    handover_generic: 'An den Versender übergeben',
    accepted: 'Vom Versender übernommen',
    hub_origin: 'Im Start-Paketzentrum',
    hub: 'Im Paketzentrum',
    hub_dest: 'Im Ziel-Paketzentrum',
    hub_near: 'Im Paketzentrum in Ihrer Nähe',
    hub_processed: 'Im Paketzentrum bearbeitet',
    customs: 'In der Zollabfertigung',
    arrived_country: 'Im Zielland angekommen',
    out_for_delivery: 'In Zustellung',
    failed: 'Zustellung nicht möglich',
    failed_attempt: 'Zustellung nicht möglich',
    attempt_failed: 'Zustellung nicht möglich',
    delivery_failed: 'Zustellung nicht möglich',
    pickup_branch: 'Zur Abholung in der Filiale',
    packstation: 'In der Packstation',
    neighbour: 'Beim Nachbarn abgegeben',
    returning: 'Auf dem Rückweg zu uns',
    delivered: 'Zugestellt',
    update: 'Neue Meldung vom Versender',
    rma_registered: 'Rücksendung angemeldet',
    rma_shipped: 'Paket an uns unterwegs',
    rma_arrived: 'Bei uns eingetroffen',
    rma_checked: 'Geprüft',
    rma_refunded: 'Erstattet'
  };
  /* Unbekannter Code: lieber Postsprache (raw) oder ein allgemeiner Satz als der Code selbst. */
  function schrittText(st) {
    if (st.c === 'other') return st.raw || SCHRITT.update;
    var t = SCHRITT[st.c];
    if (!t) {
      if (/^hub/.test(st.c)) t = SCHRITT.hub;
      else if (/fail|attempt/.test(st.c)) t = SCHRITT.failed;
      else t = st.raw || SCHRITT.update;
    }
    return t.replace('{carrier}', st.carrier || 'den Versender');
  }

  function bild(it, gr) {
    gr = gr || 56;
    var u = sicher(it.image);
    return u
      ? '<img class="rk-bild" src="' + esc(u) + '" alt="" width="' + gr + '" height="' + gr + '" loading="lazy">'
      : '<span class="rk-bild rk-bild--leer" aria-hidden="true">' + ICON.paket + '</span>';
  }
  function variante(it) {
    return it.variant && it.variant !== 'Default Title' ? '<span class="rk-art__zusatz">' + esc(it.variant) + '</span>' : '';
  }
  function artikelName(it) {
    var u = sicher(it.url);
    return u ? '<a class="rk-art__name" href="' + esc(u) + '">' + esc(it.name) + '</a>' : '<span class="rk-art__name">' + esc(it.name) + '</span>';
  }
  function artikelListe(items) {
    return '<ul class="rk-art" role="list">' + (items || []).map(function (it) {
      return '<li>' + bild(it) +
        '<span class="rk-art__text">' + artikelName(it) + variante(it) +
        '<span class="rk-art__zusatz">Menge: ' + esc(it.qty) + '</span></span></li>';
    }).join('') + '</ul>';
  }

  /* Zeitleiste wie WSTND: Punkt, Schritt, Datum und Uhrzeit. Bei vielen Schritten nur die letzten
     zwei vor dem aktuellen zeigen, der Rest lässt sich aufklappen. */
  var zeitNr = 0;
  function zeitleiste(steps, titel) {
    var schritte = steps || [];
    if (!schritte.length) return '';
    var aktuell = -1;
    schritte.forEach(function (st, i) { if (st.s === 'current' || st.s === 'problem' || st.s === 'done') aktuell = i; });
    var ab = Math.max(0, aktuell - 2);
    var viele = ab > 0;
    var id = 'rk-zeit-' + (++zeitNr);
    var h = '<ol class="rk-zeit' + (viele ? ' rk-zeit--kurz' : '') + '" id="' + id + '" aria-label="' + esc(titel || 'Verlauf der Sendung') + '">' + schritte.map(function (st, i) {
      var s = /^(done|current|problem|pending)$/.test(st.s) ? st.s : 'pending';
      var sr = s === 'done' ? 'erledigt' : (s === 'current' ? 'aktueller Stand' : (s === 'problem' ? 'hier hakt es' : 'noch offen'));
      return '<li class="rk-zeit__s rk-zeit__s--' + s + (i < ab ? ' rk-zeit__s--alt' : '') + '"' + (s === 'current' || s === 'problem' ? ' aria-current="step"' : '') + '>' +
        '<span class="rk-zeit__punkt" aria-hidden="true"></span>' +
        '<span class="rk-zeit__t">' + esc(schrittText(st)) + '<span class="visually-hidden">: ' + sr + '</span></span>' +
        (st.at ? '<span class="rk-zeit__d">' + esc(datumZeit(st.at)) + '</span>' : '') +
        '</li>';
    }).join('') + '</ol>';
    if (viele) h += '<button type="button" class="rk-link rk-link--knopf" data-rk-mehr aria-controls="' + id + '" aria-expanded="false">Frühere Schritte anzeigen (' + ab + ')</button>';
    return h;
  }
  function zeitleisteBinden(root) {
    $$('[data-rk-mehr]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var ol = document.getElementById(b.getAttribute('aria-controls')) || b.previousElementSibling;
        var alt = ol.querySelectorAll('.rk-zeit__s--alt').length;
        var kurz = ol.classList.toggle('rk-zeit--kurz');
        b.setAttribute('aria-expanded', kurz ? 'false' : 'true');
        b.textContent = kurz ? 'Frühere Schritte anzeigen (' + alt + ')' : 'Weniger anzeigen';
      });
    });
  }

  function hilfeKarte(no, mail) {
    var betreff = encodeURIComponent('Bestellung ' + no);
    return '<section class="rk-karte rk-hilfe"><h3 class="rk-h3">Fragen zu dieser Bestellung?</h3>' +
      '<p class="rk-text">Schreiben Sie uns' +
      (mail ? ' an <a class="rk-link" href="mailto:' + esc(mail) + '?subject=' + betreff + '">' + esc(mail) + '</a> (mit der Bestellnummer im Betreff) oder' : '') +
      ' über die Seite ' + kontaktLink('Kontakt') + '.</p>' +
      '</section>';
  }

  /* Die feste Zeile „Vertrag widerrufen“ unter dem Ergebnis füllt die gefundene Bestellung vor.
     Steht im Ergebnis schon ein eigener Knopf „Vertrag widerrufen“ ([data-rk-wr]), wird die Zeile
     so lange ausgeblendet – sonst stünde derselbe Link zweimal untereinander. */
  function widerrufLink(root, no, email) {
    $$('.rk-p-wr__link', root).forEach(function (a) { a.setAttribute('href', SEITE_WIDERRUF + abfrage(no, email)); });
    var doppelt = !!$('[data-rk-out] [data-rk-wr]', root);
    $$('.rk-p-wr', root).forEach(function (p) { p.hidden = doppelt; });
  }

  /* ---------- Bestellstatus ---------- */
  function initTrack(root) {
    beispielLesen(root);
    var form = $('form', root);
    var out = $('[data-rk-out]', root);
    if (!form || !out || !form.elements.no || !form.elements.email) return;
    var base = root.getAttribute('data-rk-api');
    var mail = root.getAttribute('data-rk-mail') || '';
    var sucht = false;
    feldBeobachten(form);

    var q = new URLSearchParams(location.search);
    if (q.get('no')) form.elements.no.value = q.get('no');
    if (q.get('email')) form.elements.email.value = q.get('email');

    function suchen() {
      if (sucht) return;
      var eingabe = sucheLesen(form, root);
      if (!eingabe) return;
      var feh = $('[data-rk-formfehler]', form);
      var btn = $('button[type=submit]', form);
      sucht = true;
      btn.disabled = true; btn.textContent = 'Wird gesucht …';
      ansage(root, 'Bestellung wird gesucht.');
      out.innerHTML = '';
      holen(api(base, '/api/track') + abfrage(eingabe.no, eingabe.email) + '&lang=' + LANG, {}, T_SUCHE).then(function (r) {
        sucht = false;
        btn.disabled = false; btn.textContent = 'Bestellung suchen';
        if (!r.ok || !r.data) {
          formularZeigen(root);
          ansage(root, '');
          zeigeFehler(feh, fehlerText(r.error, 'suche'));
          return;
        }
        var no = r.data.id || eingabe.no;
        suchleiste(root, no, eingabe.email);
        out.innerHTML = renderTrack(r.data, no, eingabe.email, mail);
        widerrufLink(root, no, eingabe.email);
        zeitleisteBinden(out);
        ansage(root, 'Bestellung gefunden.');
        nachOben(root);
        fokus($('[data-rk-fokus]', out));
      });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); suchen(); });
    if (q.get('no') && q.get('email')) suchen();
  }

  function stufe(d) {
    if (d.state === 'storniert') return 0;
    if (d.state === 'zugestellt') return 4;
    if (d.state === 'bearbeitung') return 1;
    var zustellung = (d.shipments || []).some(function (s) {
      return (s.steps || []).some(function (st) { return st.c === 'out_for_delivery' && st.s === 'current'; });
    });
    return zustellung ? 3 : 2;
  }

  function fortschritt(n, problem) {
    var namen = ['Bestellt', 'Versandt', 'In Zustellung', 'Zugestellt'];
    return '<ol class="rk-fort' + (problem ? ' rk-fort--problem' : '') + '" aria-label="Fortschritt der Bestellung">' + namen.map(function (t, i) {
      var k = i + 1;
      var cls = k < n || (k === n && n === 4) ? 'is-fertig' : (k === n ? 'is-aktiv' : '');
      if (n === 1 && k === 1) cls = 'is-fertig';
      var sr = cls === 'is-fertig' ? ': erledigt' : (cls === 'is-aktiv' ? ': aktueller Stand' : ': noch offen');
      return '<li class="' + cls + '"' + (k === n ? ' aria-current="step"' : '') + '><span class="rk-fort__balken" aria-hidden="true"></span><span class="rk-fort__t">' + t + '<span class="visually-hidden">' + sr + '</span></span></li>';
    }).join('') + '</ol>';
  }

  /* Letzter Schritt einer Sendung, der schon passiert ist oder gerade läuft. */
  function letzterSchritt(s) {
    var l = null;
    (s.steps || []).forEach(function (st) { if (st.s === 'done' || st.s === 'current' || st.s === 'problem') l = st; });
    return l;
  }

  function renderTrack(d, no, email, mail) {
    var st = STATUS[d.state];
    var n = stufe(d);
    var sendungen = d.shipments || [];
    var offen = d.open || [];
    var viele = sendungen.length > 1;
    var titel = etaText(d.eta, d);
    var zusatz = etaZusatz(d.eta);
    /* Teilweise versandt: Ein Teil der Artikel hat noch keine Sendung. Der Worker meldet dann
       „deliver_soon“, auch wenn alle Pakete schon da sind – deshalb hier eigene Sätze. */
    if (d.state === 'teilweise') {
      var alleDa = sendungen.length > 0 && sendungen.every(function (s) { return s.state === 'zugestellt'; });
      if (alleDa) titel = 'Ein Teil Ihrer Bestellung ist angekommen';
      zusatz = 'Ein Teil Ihrer Bestellung ist noch nicht versandt. Welche Artikel, sehen Sie unten unter „Noch nicht versandt“.';
    }
    if (!titel) titel = st ? st[0] : 'Ihre Bestellung';
    var h = '<section class="rk-karte rk-karte--status">' +
      '<div class="rk-kopf">' + (d.placedAt ? '<p class="rk-klein">Bestellung ' + esc(no) + ' vom ' + esc(datumKurz(d.placedAt)) + '</p>' : '<p class="rk-klein">Bestellung ' + esc(no) + '</p>') +
      (st ? '<span class="rk-st ' + st[1] + '">' + esc(st[0]) + '</span>' : '') + '</div>' +
      '<h2 class="rk-h2" data-rk-fokus>' + esc(titel) + '</h2>' +
      (zusatz ? '<p class="rk-text">' + esc(zusatz) + (/schreiben Sie uns/.test(zusatz) ? ' ' + kontaktLink('Zur Seite „Kontakt“') : '') + '</p>' : '') +
      (n ? fortschritt(n, d.state === 'verzoegert') : '') +
      '</section>';

    sendungen.forEach(function (s) {
      var sst = STATUS[s.state];
      var link = sicher(s.trackUrl);
      var letzter = letzterSchritt(s);
      var hinweis = '';
      if (letzter && letzter.c === 'returning' && s.state !== 'zugestellt') {
        hinweis = 'Dieses Paket ist auf dem Rückweg zu uns. Bitte schreiben Sie uns, wenn Sie Fragen dazu haben.';
      } else if (viele && s.state === 'verzoegert') {
        hinweis = 'Bei diesem Paket gibt es seit einigen Tagen keine neue Meldung vom Versender.';
      }
      h += '<section class="rk-karte">' +
        '<div class="rk-kopf"><h3 class="rk-h3">' + ICON.lkw +
        (viele ? 'Paket ' + esc(s.nr) + ' von ' + sendungen.length : 'Ihre Sendung') + (s.carrier ? ' · ' + esc(s.carrier) : '') + '</h3>' +
        (viele && sst ? '<span class="rk-st ' + sst[1] + '">' + esc(sst[0]) + '</span>' : '') + '</div>' +
        (s.dueAt && s.state !== 'zugestellt' ? '<p class="rk-prognose"><span>Voraussichtliche Zustellung</span> <strong>' + esc(datum(s.dueAt)) + '</strong></p>' : '') +
        (s.tracking ? '<p class="rk-sendnr">Sendungsnummer <strong>' + esc(s.tracking) + '</strong>' +
          (link ? ' <a class="rk-link" href="' + esc(link) + '" target="_blank" rel="noopener">Sendung bei ' + esc(s.carrier || 'dem Versender') + ' verfolgen<span class="visually-hidden"> (öffnet ein neues Fenster)</span></a>' : '') + '</p>' : '') +
        (hinweis ? '<p class="rk-hinweis rk-hinweis--gelb">' + ICON.info + '<span>' + esc(hinweis) + '</span></p>' : '') +
        zeitleiste(s.steps, viele ? 'Verlauf von Paket ' + s.nr : 'Verlauf der Sendung') +
        ((s.items && s.items.length) ? '<div class="rk-trenner"></div>' + artikelListe(s.items) : '') +
        '</section>';
    });

    if (offen.length) {
      h += '<section class="rk-karte"><h3 class="rk-h3">' + ICON.paket + 'Noch nicht versandt</h3>' + artikelListe(offen) + '</section>';
    }
    if (!sendungen.length && !offen.length && d.state !== 'storniert') {
      h += '<section class="rk-karte"><p class="rk-text rk-text--ohne">Zu dieser Bestellung gibt es noch keine Angaben zum Versand.</p></section>';
    }

    var unten = '';
    if (d.shipTo && d.shipTo.length) {
      unten += '<div><h3 class="rk-h4">Lieferadresse</h3><p class="rk-text">' + d.shipTo.map(esc).join('<br>') + '</p>' +
        (d.state === 'bearbeitung' ? '<p class="rk-klein">Stimmt die Adresse nicht? Schreiben Sie uns bitte sofort – solange das Paket noch nicht unterwegs ist, können wir sie meist noch ändern.</p>' : '') +
        '</div>';
    }
    /* Rückgabefrist ab Zustellung – gerechnet vom Worker (returnUntil, returnOpen). */
    if (d.deliveredAt) {
      var bis = datumKurz(d.returnUntil);
      var frist = tage(d.returnDays || 30);
      unten += '<div><h3 class="rk-h4">Rückgabe</h3>' + (d.returnOpen
        ? '<p class="rk-text">' + (bis ? 'Möglich bis zum ' + esc(bis) + ' (' + esc(frist) + ' ab Zustellung).' : 'Möglich ' + esc(frist) + ' ab Zustellung.') + '</p><a class="rk-btn rk-btn--hell rk-btn--klein" href="' + SEITE_RETOURE + abfrage(no, email) + '">Rücksendung anmelden</a>'
        : '<p class="rk-text">Die Rückgabefrist (' + esc(frist) + ' ab Zustellung) ist ' + (bis ? 'am ' + esc(bis) + ' ' : '') + 'abgelaufen. Bei einem Mangel gilt die gesetzliche Gewährleistung – ' + kontaktLink('schreiben Sie uns') + '.</p>') + '</div>';
    }
    if (unten) h += '<section class="rk-karte rk-karte--spalten">' + unten + '</section>';
    h += hilfeKarte(no, mail);
    return h;
  }

  /* ---------- Rücksendung ---------- */
  /* „Entspricht nicht der Beschreibung“ ist rechtlich ein Mangel und gehört zu den kostenlosen
     Gründen – der Worker rechnet passt_nicht aber mit Labelgebühr. Deshalb steht es hier beim
     Grund „defekt“. */
  var GRUENDE = [
    ['gefaellt_nicht', 'Gefällt mir nicht / anders überlegt'],
    ['defekt', 'Beschädigt, defekt oder nicht wie beschrieben'],
    ['falsch', 'Falscher Artikel geliefert'],
    ['anderer', 'Anderer Grund']
  ];
  var KOSTENLOS = ['defekt', 'falsch'];

  /* Regel je Lieferland – so, wie der Worker sie liefert (buildReturnView: country, returnDays,
     labelFee, labelAvailable). Fehlt labelFee (älterer Worker), gilt der Preis aus rk-api.liquid. */
  function regel(d, preis) {
    var land = String(d.country || 'DE').toUpperCase();
    var fee = (typeof d.labelFee === 'number' && isFinite(d.labelFee)) ? d.labelFee : preis;
    return {
      land: land,
      de: land === 'DE',
      zoll: EU_ZOLL.indexOf(land) === -1,
      gebuehr: Math.max(0, fee || 0),
      label: !!d.labelAvailable,
      tage: Number(d.returnDays) || 30
    };
  }
  function adresseVon(stand, res) {
    if (res && Array.isArray(res.address) && res.address.length) return res.address;
    var z = String(stand.adresse || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
    if (z.length && stand.regel && !stand.regel.de) z.push('DEUTSCHLAND');
    return z;
  }
  function adresseBlock(zeilen) {
    if (!zeilen || !zeilen.length) return '';
    return '<div class="rk-adresse"><p class="rk-klein">Rücksendeadresse</p><p class="rk-adresse__text">' + zeilen.map(esc).join('<br>') + '</p></div>';
  }

  function initReturn(root) {
    beispielLesen(root);
    var form = $('form', root);
    var out = $('[data-rk-out]', root);
    if (!form || !out || !form.elements.no || !form.elements.email) return;
    var base = root.getAttribute('data-rk-api');
    var preis = parseFloat(String(root.getAttribute('data-rk-label-preis') || '0').replace(',', '.')) || 0;
    var sucht = false;
    feldBeobachten(form);

    var q = new URLSearchParams(location.search);
    if (q.get('no')) form.elements.no.value = q.get('no');
    if (q.get('email')) form.elements.email.value = q.get('email');
    schritt(root, 1);

    function suchen() {
      if (sucht) return;
      var eingabe = sucheLesen(form, root);
      if (!eingabe) return;
      var feh = $('[data-rk-formfehler]', form);
      var btn = $('button[type=submit]', form);
      sucht = true;
      btn.disabled = true; btn.textContent = 'Wird gesucht …';
      ansage(root, 'Bestellung wird gesucht.');
      out.innerHTML = '';
      holen(api(base, '/api/track') + abfrage(eingabe.no, eingabe.email) + '&lang=' + LANG + '&scope=return', {}, T_SUCHE).then(function (r) {
        sucht = false;
        btn.disabled = false; btn.textContent = 'Weiter';
        if (!r.ok || !r.data) {
          /* Kam die Suche aus „Stand prüfen“, ist das Formular eingeklappt. */
          formularZeigen(root);
          schritt(root, 1);
          ansage(root, '');
          zeigeFehler(feh, fehlerText(r.error, 'suche'));
          return;
        }
        var d = r.data;
        var stand = {
          no: d.id || eingabe.no, email: eingabe.email, d: d, base: base, root: root, neuSuchen: suchen,
          mail: root.getAttribute('data-rk-mail') || '',
          adresse: root.getAttribute('data-rk-adresse') || '',
          regel: regel(d, preis)
        };
        suchleiste(root, stand.no, eingabe.email);
        out.innerHTML = renderReturn(stand);
        widerrufLink(root, stand.no, eingabe.email);
        schritt(root, d.openReturn ? 4 : ((d.block || d.state === 'storniert' || stand.leer) ? 1 : 2));
        bindReturn(stand, out);
        zeitleisteBinden(out);
        ansage(root, 'Bestellung gefunden.');
        nachOben(root);
        fokus($('[data-rk-fokus]', out));
      });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); suchen(); });
    if (q.get('no') && q.get('email')) suchen();
  }

  /* Belege: QR-Code direkt sichtbar (zum Vorzeigen in der Filiale), Label und Retourenschein als
     schlichte Links – jeder PDF-Betrachter hat einen Druckknopf (WSTND: Druck per Skript
     scheiterte auf dem iPhone). */
  function belege(o, base) {
    var qr = beleg(o.qrUrl, base), label = beleg(o.labelUrl, base), schein = beleg(o.slipUrl, base);
    if (!qr && !label && !schein) return '';
    var h = '<section class="rk-karte"><h3 class="rk-h3">Ihre Unterlagen</h3>';
    if (qr) {
      h += '<div class="rk-qr"><img src="' + esc(qr) + '" alt="DHL-QR-Code für Ihre Rücksendung" width="160" height="160">' +
        '<p class="rk-text rk-text--ohne"><strong>Kein Drucker?</strong> Zeigen Sie diesen Code in einer DHL-Filiale – dort wird das Label ausgedruckt.</p></div>';
    }
    h += '<div class="rk-belege">';
    if (label) h += '<a class="rk-beleg rk-beleg--haupt" href="' + esc(label) + '" target="_blank" rel="noopener">' + ICON.drucker + '<span><strong>DHL-Retourenlabel</strong><small>PDF zum Ausdrucken, öffnet ein neues Fenster</small></span></a>';
    if (schein) h += '<a class="rk-beleg" href="' + esc(schein) + '" target="_blank" rel="noopener">' + ICON.doku + '<span><strong>Retourenschein</strong><small>PDF, gehört ins Paket, öffnet ein neues Fenster</small></span></a>';
    h += '</div>';
    if (schein) h += '<p class="rk-klein rk-abstand">Bitte legen Sie den Retourenschein ins Paket – ohne ihn können wir die Rücksendung Ihrer Bestellung nicht zuordnen.</p>';
    return h + '</section>';
  }

  function naechsteSchritte(mitLabel, zoll) {
    var s = mitLabel
      ? ['Retourenschein ausdrucken und ins Paket legen.',
        'DHL-Label aufs Paket kleben – oder den QR-Code in einer DHL-Filiale zeigen, dort wird das Label gedruckt.',
        'Paket innerhalb von 14 Tagen bei DHL abgeben und den Einlieferungsbeleg aufheben, bis das Geld zurück ist.',
        'Nach der Prüfung erstatten wir den Betrag auf Ihr ursprüngliches Zahlungsmittel.']
      : ['Retourenschein ausdrucken und ins Paket legen – nur so können wir die Rücksendung Ihrer Bestellung zuordnen.',
        'Paket ausreichend frankiert und mit Sendungsverfolgung an die Rücksendeadresse schicken (sie steht auch auf dem Retourenschein).',
        'Paket innerhalb von 14 Tagen abschicken und den Einlieferungsbeleg aufheben, bis das Geld zurück ist.',
        'Nach der Prüfung erstatten wir den Betrag auf Ihr ursprüngliches Zahlungsmittel.'];
    if (zoll) s.splice(2, 0, ZOLL_HINWEIS);
    return '<ol class="rk-naechste">' + s.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ol>';
  }

  function erstattungsSatz(betrag, versand) {
    if (typeof betrag !== 'number' || !isFinite(betrag)) return '';
    return '<p class="rk-text">Nach der Prüfung erstatten wir Ihnen <strong>' + esc(eur(betrag)) + '</strong> auf Ihr ursprüngliches Zahlungsmittel' +
      (versand > 0 ? ', darin enthalten ' + esc(eur(versand)) + ' Versandkosten' : '') + '.</p>';
  }

  /* Bereits angemeldete Rücksendung: Nummer, Belege, Stand. */
  function laufendeAnsicht(stand) {
    var o = stand.d.openReturn;
    var mitLabel = !!(beleg(o.labelUrl, stand.base) || beleg(o.qrUrl, stand.base));
    var mitSchein = !!beleg(o.slipUrl, stand.base);
    return '<section class="rk-karte rk-karte--erfolg">' +
      '<span class="rk-erfolg__icon">' + ICON.haken + '</span>' +
      '<h2 class="rk-h2" data-rk-fokus>Ihre Rücksendung ist angemeldet</h2>' +
      '<p class="rk-klein">Rücksendenummer</p>' +
      '<p class="rk-rma">' + esc(o.rma) + '</p>' +
      '<p class="rk-text">Angemeldet am ' + esc(datumKurz(o.createdAt)) + (o.shipmentNo ? ' · DHL-Sendungsnummer ' + esc(o.shipmentNo) : '') + '.</p>' +
      erstattungsSatz(typeof o.refund === 'number' ? o.refund : NaN, Number(o.shippingRefund) || 0) +
      '</section>' +
      belege(o, stand.base) +
      (mitLabel ? '' : '<section class="rk-karte">' + adresseBlock(adresseVon(stand)) + '</section>') +
      ((mitLabel || mitSchein) ? '<section class="rk-karte"><h3 class="rk-h3">So geht es weiter</h3>' + naechsteSchritte(mitLabel, stand.regel.zoll) + '</section>' : '') +
      (o.steps && o.steps.length ? '<section class="rk-karte"><h3 class="rk-h3">Stand Ihrer Rücksendung</h3>' + zeitleiste(o.steps, 'Stand Ihrer Rücksendung') + '</section>' : '') +
      hilfeKarte(stand.no, stand.mail);
  }

  function hinweisKarte(titel, saetze, knoepfe) {
    return '<section class="rk-karte"><h2 class="rk-h2" data-rk-fokus>' + esc(titel) + '</h2>' +
      saetze.map(function (s) { return '<p class="rk-text">' + s + '</p>'; }).join('') +
      (knoepfe ? '<div class="rk-knoepfe">' + knoepfe + '</div>' : '') + '</section>';
  }

  function renderReturn(stand) {
    var d = stand.d, rg = stand.regel;
    if (d.openReturn) return laufendeAnsicht(stand);
    var widerrufKnopf = '<a class="rk-btn rk-btn--hell" data-rk-wr href="' + SEITE_WIDERRUF + abfrage(stand.no, stand.email) + '">' + ICON.zurueck + '<span>Vertrag widerrufen</span></a>';
    var kontaktKnopf = '<a class="rk-btn rk-btn--hell" href="' + SEITE_KONTAKT + '">Zur Seite „Kontakt“</a>';

    /* Sperrgründe des Workers: 'unterwegs' (noch nicht alles zugestellt) und 'frist' (Frist vorbei,
       auch nach einem Widerruf). Unbekannte Gründe bekommen einen allgemeinen Satz – nie den Code. */
    if (d.state === 'storniert') {
      return hinweisKarte('Diese Bestellung wurde storniert',
        [esc('Für eine stornierte Bestellung können Sie hier keine Rücksendung anmelden. Haben Sie Fragen dazu? Dann schreiben Sie uns.')], kontaktKnopf);
    }
    if (d.block === 'unterwegs') {
      var pakete = d.shipments || [];
      var teils = pakete.some(function (s) { return s.state === 'zugestellt'; });
      var titel = !pakete.length ? 'Ihre Bestellung ist noch nicht verschickt'
        : (teils ? 'Ein Teil Ihrer Bestellung ist noch unterwegs' : 'Ihr Paket ist noch unterwegs');
      var satz = teils
        ? 'Eine Rücksendung können Sie anmelden, sobald alle Pakete bei Ihnen angekommen sind. Die Rückgabefrist beginnt erst mit der letzten Zustellung.'
        : 'Eine Rücksendung können Sie anmelden, sobald die Ware bei Ihnen angekommen ist. Die Rückgabefrist beginnt erst mit der Zustellung.';
      return hinweisKarte(titel, [esc(satz), esc('Sie möchten die Bestellung nicht mehr? Den Widerruf können Sie schon jetzt erklären.')],
        '<a class="rk-btn rk-btn--hell" href="' + SEITE_TRACKING + abfrage(stand.no, stand.email) + '">Sendung verfolgen</a>' + widerrufKnopf);
    }
    if (d.block === 'frist') {
      return hinweisKarte('Die Rückgabefrist ist abgelaufen', [
        esc((d.deliveredAt ? 'Zugestellt am ' + datumKurz(d.deliveredAt) + '. ' : '') + 'Die Rückgabefrist von ' + tage(rg.tage) + ' ab Zustellung ist vorbei.'),
        esc('Bei einem Mangel gilt die gesetzliche Gewährleistung. Schreiben Sie uns, wir helfen Ihnen weiter.')
      ], kontaktKnopf);
    }
    if (d.block) {
      return hinweisKarte('Eine Rücksendung ist hier gerade nicht möglich', [esc('Bitte schreiben Sie uns, wir helfen Ihnen weiter.')], kontaktKnopf);
    }

    var items = d.items || [];
    /* Der Worker spricht Artikel über die SKU an. Teilen sich zwei Zeilen eine SKU (oder fehlt sie
       mehrfach), wäre die Zuordnung unklar – diese Artikel lieber nicht online anbieten. */
    var zahl = {};
    items.forEach(function (it) { var k = String(it.sku == null ? '' : it.sku); zahl[k] = (zahl[k] || 0) + 1; });
    /* Artikel ohne Sendung (Teillieferung, d.open) sind noch nicht beim Kunden. */
    var nichtVersandt = {};
    (d.open || []).forEach(function (it) { nichtVersandt[String(it.sku == null ? '' : it.sku)] = true; });
    stand.gesperrt = items.map(function (it) {
      var k = String(it.sku == null ? '' : it.sku);
      if (zahl[k] > 1) return 'unklar';
      if (nichtVersandt[k]) return 'offen';
      return '';
    });
    var waehlbar = stand.gesperrt.filter(function (g) { return !g; }).length;

    /* Leerer Zustand: nichts, was sich online zurückschicken lässt. */
    if (!waehlbar) {
      stand.leer = true;
      return hinweisKarte('Hier ist keine Auswahl möglich', [
        esc(items.length
          ? 'Die Artikel dieser Bestellung können Sie hier nicht online zurückschicken. Bitte schreiben Sie uns, wir helfen Ihnen weiter.'
          : 'Zu dieser Bestellung finden wir keine Artikel, die Sie zurückschicken können. Bitte schreiben Sie uns, wir helfen Ihnen weiter.')
      ], kontaktKnopf);
    }

    var zeilen = items.map(function (it, i) {
      var max = Math.max(1, Number(it.qty || 1));
      if (stand.gesperrt[i]) {
        return '<li class="rk-wahl rk-wahl--aus"><div class="rk-wahl__kopf">' + bild(it, 64) +
          '<span class="rk-art__text">' + artikelName(it) + variante(it) +
          (stand.gesperrt[i] === 'offen'
            ? '<span class="rk-art__zusatz">Noch nicht versandt – zurückschicken können Sie diesen Artikel, sobald er bei Ihnen ist.</span>'
            : '<span class="rk-art__zusatz">Diesen Artikel können Sie hier nicht auswählen – bitte ' + kontaktLink('schreiben Sie uns') + '.</span>') +
          '</span></div></li>';
      }
      var mengeFeld;
      if (max > 1) {
        var opts = '';
        for (var n = 1; n <= max; n++) opts += '<option value="' + n + '"' + (n === max ? ' selected' : '') + '>' + n + ' von ' + max + '</option>';
        mengeFeld = '<div class="rk-feld rk-feld--menge"><label for="rk-menge-' + i + '">Wie viele senden Sie zurück?</label><select id="rk-menge-' + i + '" name="qty-' + i + '">' + opts + '</select></div>';
      } else {
        mengeFeld = '<input type="hidden" name="qty-' + i + '" value="1">';
      }
      return '<li class="rk-wahl" data-i="' + i + '">' +
        '<label class="rk-wahl__kopf" for="rk-pick-' + i + '">' +
        '<input type="checkbox" class="rk-wahl__check" id="rk-pick-' + i + '" name="pick-' + i + '" aria-controls="rk-mehr-' + i + '">' +
        '<span class="rk-wahl__box" aria-hidden="true">' + ICON.haken + '</span>' +
        bild(it, 64) +
        '<span class="rk-art__text"><span class="rk-art__name">' + esc(it.name) + '</span>' + variante(it) +
        '<span class="rk-art__zusatz">' + esc(eur(it.price)) + (max > 1 ? ' · ' + max + ' Stück bestellt' : '') + '</span></span>' +
        '</label>' +
        '<div class="rk-wahl__mehr" id="rk-mehr-' + i + '" hidden>' + mengeFeld +
        '<fieldset class="rk-gruende" id="rk-grund-' + i + '" role="radiogroup" aria-required="true"><legend>Warum senden Sie zurück?</legend>' +
        GRUENDE.map(function (g) {
          return '<label class="rk-grund"><input type="radio" name="reason-' + i + '" value="' + g[0] + '"><span>' + esc(g[1]) + '</span></label>';
        }).join('') + '</fieldset>' +
        '<details class="rk-notiz"><summary>Anmerkung hinzufügen (optional)</summary>' +
        '<label class="visually-hidden" for="rk-notiz-' + i + '">Anmerkung zu ' + esc(it.name) + '</label>' +
        '<textarea id="rk-notiz-' + i + '" name="note-' + i + '" maxlength="300" rows="2" placeholder="z. B. was genau defekt ist"></textarea>' +
        '<p class="rk-klein rk-notiz__foto" hidden>Ein Foto' + (stand.mail ? ' an ' + esc(stand.mail) : '') + ' (mit der Bestellnummer im Betreff) beschleunigt die Prüfung.</p>' +
        '</details>' +
        '</div></li>';
    }).join('');

    var weg;
    if (rg.label) {
      weg = '<fieldset class="rk-wege"><legend class="visually-hidden">Versandart für die Rücksendung</legend>' +
        '<label class="rk-weg"><input type="radio" name="method" value="label" checked><span class="rk-weg__inhalt">' + ICON.drucker +
        '<span><strong>DHL-Retourenlabel von uns</strong><small>Kommt sofort als PDF und QR-Code. Paket in einer DHL-Filiale oder Packstation abgeben.' +
        (rg.gebuehr > 0 ? ' Das Label kostet ' + esc(eur(rg.gebuehr)) + ' – der Betrag wird von der Erstattung abgezogen.' : '') + '</small></span>' +
        '<span class="rk-weg__preis" data-rk-labelpreis>' + (rg.gebuehr > 0 ? esc(eur(rg.gebuehr)) : 'kostenlos') + '</span></span></label>' +
        '<label class="rk-weg"><input type="radio" name="method" value="selbst"><span class="rk-weg__inhalt">' + ICON.paket +
        '<span><strong>Ich verschicke selbst</strong><small>Mit einem Versanddienst Ihrer Wahl, ausreichend frankiert und mit Sendungsverfolgung. Das Porto zahlen Sie beim Versand.</small></span>' +
        '<span class="rk-weg__preis">kein Abzug</span></span></label>' +
        '</fieldset>' +
        (rg.gebuehr > 0 ? '<p class="rk-hinweis">' + ICON.info + '<span>Bei einem Defekt, einer Falschlieferung oder wenn der Artikel nicht der Beschreibung entspricht, ist das Label kostenlos.</span></p>' : '');
    } else {
      weg = '<p class="rk-hinweis">' + ICON.info + '<span>Bitte schicken Sie das Paket selbst an uns zurück – ausreichend frankiert und mit Sendungsverfolgung. Die Anschrift steht auf dem Retourenschein, den Sie gleich bekommen.</span></p>';
    }
    if (rg.zoll) weg += '<p class="rk-hinweis">' + ICON.info + '<span>' + esc(ZOLL_HINWEIS) + '</span></p>';

    /* daysLeft rechnet der Worker – nach einem erklärten Widerruf schon mit der verlängerten
       Frist (14 Tage ab Widerruf). */
    var frist = Number(d.daysLeft);
    var fristText = (d.daysLeft == null || !isFinite(frist)) ? '' : (frist <= 0 ? 'Heute letzter Tag für die Rückgabe' : 'Noch ' + tage(frist) + ' Zeit für die Rückgabe');
    var seit = zeit(d.deliveredAt) ? Math.floor((Date.now() - zeit(d.deliveredAt).getTime()) / 864e5) : null;
    var verlaengert = fristText && seit !== null && frist > rg.tage - seit;

    return '<form data-rk-ret novalidate>' +
      '<section class="rk-karte">' +
      '<div class="rk-kopf"><h2 class="rk-h2 rk-h2--nr" data-rk-fokus><span class="rk-nr" aria-hidden="true">2</span>Artikel auswählen</h2>' +
      (fristText ? '<span class="rk-frist">' + esc(fristText) + '</span>' : '') + '</div>' +
      '<p class="rk-klein">Bestellung ' + esc(stand.no) + (d.deliveredAt ? ', zugestellt am ' + esc(datumKurz(d.deliveredAt)) : '') + '</p>' +
      (verlaengert ? '<p class="rk-klein">Ihre Frist ist durch Ihren Widerruf verlängert.</p>' : '') +
      '<ul class="rk-wahlliste" role="list">' + zeilen + '</ul></section>' +
      '<section class="rk-karte" data-rk-teil3>' +
      '<h2 class="rk-h2 rk-h2--nr"><span class="rk-nr" aria-hidden="true">3</span>Versand</h2>' + weg +
      '<p class="rk-hinweis" data-rk-porto hidden>' + ICON.info + '<span>Bei einem Defekt oder einer Falschlieferung tragen wir die Rücksendekosten: Heben Sie den Portobeleg auf und ' + kontaktLink('schreiben Sie uns kurz') + ' – wir erstatten Ihnen das Porto.</span></p>' +
      '</section>' +
      '<section class="rk-karte rk-karte--summe">' +
      '<dl class="rk-summe" data-rk-summe></dl>' +
      '<p class="rk-klein rk-abstand" data-rk-versandhinweis hidden>Geht die ganze Bestellung innerhalb von 14 Tagen nach Zustellung zurück, erstatten wir auch die bezahlten Versandkosten (Standardversand).</p>' +
      '<div data-rk-fehler></div>' +
      '<button class="rk-btn rk-btn--voll" type="submit">Rücksendung verbindlich anmelden</button>' +
      '<p class="rk-klein rk-zentriert" data-rk-sendetext></p>' +
      '</section></form>';
  }

  function bindReturn(stand, out) {
    var f = $('form[data-rk-ret]', out);
    if (!f) return;
    var root = stand.root, base = stand.base, rg = stand.regel;
    var items = stand.d.items || [];
    var fehler = $('[data-rk-fehler]', f);
    var summe = $('[data-rk-summe]', f);
    var sendet = false;
    var gesperrt = stand.gesperrt || [];
    feldBeobachten(f);

    /* Nur ein Artikel? Dann gleich vorauswählen. */
    var waehlbar = items.filter(function (it, i) { return !gesperrt[i]; });
    if (items.length === 1 && waehlbar.length === 1) { var c = f.elements['pick-0']; if (c) c.checked = true; }

    function geliefertVorTagen() {
      var d = zeit(stand.d.deliveredAt);
      return d ? Math.floor((Date.now() - d.getTime()) / 864e5) : 999;
    }

    function auswahl() {
      var sel = {}, waren = 0, frei = false, anzahl = 0, ohneGrund = -1, ganz = true;
      items.forEach(function (it, i) {
        var box = f.elements['pick-' + i];
        if (!box || !box.checked) { ganz = false; return; }
        var qty = parseInt(f.elements['qty-' + i].value, 10) || 1;
        if (qty < Number(it.qty || 1)) ganz = false;
        var r = f.querySelector('input[name="reason-' + i + '"]:checked');
        var reason = r ? r.value : '';
        if (!reason && ohneGrund < 0) ohneGrund = i;
        sel[it.sku] = { qty: qty, reason: reason, note: (f.elements['note-' + i].value || '').slice(0, 300) };
        waren += Number(it.price || 0) * qty;
        if (KOSTENLOS.indexOf(reason) !== -1) frei = true;
        anzahl++;
      });
      var m = f.querySelector('input[name=method]:checked');
      var method = rg.label ? (m ? m.value : 'label') : 'selbst';
      var gebuehr = (!frei && method === 'label') ? rg.gebuehr : 0;
      return { sel: sel, anzahl: anzahl, waren: waren, gebuehr: gebuehr, frei: frei, method: method, ohneGrund: ohneGrund, ganz: ganz && anzahl > 0, erstattung: Math.max(0, waren - gebuehr) };
    }

    function aktualisieren() {
      $$('.rk-wahl[data-i]', f).forEach(function (li) {
        var i = li.getAttribute('data-i');
        var an = $('.rk-wahl__check', li).checked;
        li.classList.toggle('is-gewaehlt', an);
        $('.rk-wahl__mehr', li).hidden = !an;
        /* Bei Defekt/Falschlieferung die Anmerkung öffnen und auf das Foto hinweisen. */
        var r = f.querySelector('input[name="reason-' + i + '"]:checked');
        var grund = r ? r.value : '';
        var notiz = $('.rk-notiz', li);
        var foto = $('.rk-notiz__foto', li);
        if (foto) foto.hidden = KOSTENLOS.indexOf(grund) === -1;
        if (notiz && KOSTENLOS.indexOf(grund) !== -1 && !notiz.hasAttribute('data-rk-auf')) { notiz.open = true; notiz.setAttribute('data-rk-auf', ''); }
      });
      var a = auswahl();
      var lp = $('[data-rk-labelpreis]', f);
      if (lp && rg.gebuehr > 0) lp.innerHTML = a.frei ? '<s>' + esc(eur(rg.gebuehr)) + '</s> kostenlos' : esc(eur(rg.gebuehr));
      var porto = $('[data-rk-porto]', f);
      if (porto) porto.hidden = !(a.frei && a.method === 'selbst');
      var vh = $('[data-rk-versandhinweis]', f);
      if (vh) vh.hidden = !(a.ganz && geliefertVorTagen() <= 14);
      var st = $('[data-rk-sendetext]', f);
      if (st) st.textContent = a.method === 'label'
        ? 'Label und Retourenschein bekommen Sie sofort hier. Bitte schicken Sie das Paket innerhalb von 14 Tagen ab.'
        : 'Den Retourenschein bekommen Sie sofort hier. Bitte schicken Sie das Paket innerhalb von 14 Tagen ab.';
      schritt(root, a.anzahl ? (a.ohneGrund >= 0 ? 2 : 3) : 2);
      summe.innerHTML = a.anzahl
        ? '<div><dt>Warenwert (' + a.anzahl + ' Artikel)</dt><dd>' + esc(eur(a.waren)) + '</dd></div>' +
          (a.method === 'label' ? '<div><dt>DHL-Retourenlabel</dt><dd>' + (a.gebuehr ? '− ' + esc(eur(a.gebuehr)) : 'kostenlos') + '</dd></div>' : '') +
          '<div class="rk-summe__gesamt"><dt>Ihre Erstattung</dt><dd>' + esc(eur(a.erstattung)) + '</dd></div>'
        : '<div class="rk-summe__leer"><dt>Noch kein Artikel ausgewählt</dt><dd></dd></div>';
    }
    f.addEventListener('change', aktualisieren);
    aktualisieren();

    /* Während des Absendens alles sperren: kein zweiter Klick, kein Umschalten. */
    function sperren(an) {
      $$('input, select, textarea, button', f).forEach(function (x) { x.disabled = an; });
    }

    f.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sendet) return;
      var a = auswahl();
      if (!a.anzahl) {
        zeigeFehler(fehler, fehlerText('qty_invalid'), '', [$('.rk-wahl__check', f)]); return;
      }
      if (a.ohneGrund >= 0) {
        zeigeFehler(fehler, fehlerText('reason_invalid'), '', [$('#rk-grund-' + a.ohneGrund, f)]); return;
      }
      fehlerWeg(fehler);

      var btn = $('button[type=submit]', f);
      sendet = true;
      sperren(true);
      btn.textContent = 'Wird angemeldet …';
      ansage(root, 'Rücksendung wird angemeldet.');
      holen(api(base, '/api/returns'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order: stand.no, email: stand.email, method: a.method, payout: 'erstattung', items: a.sel, lang: LANG })
      }, T_ANLEGEN).then(function (r) {
        if (!r.ok || !r.data || !r.data.rma) {
          var code = r.ok ? 'server_error' : r.error;
          /* Zeitlimit: Die Rücksendung kann trotzdem entstanden sein. Knopf gesperrt lassen und den
             Stand neu abfragen lassen – sonst meldet der Kunde doppelt an. */
          if (code === 'timeout' || code === 'return_open') {
            zeigeFehler(fehler, fehlerText(code === 'timeout' ? 'langsam' : code),
              '<button type="button" class="rk-btn rk-btn--hell rk-btn--klein" data-rk-neu>Stand prüfen</button>');
            var neu = $('[data-rk-neu]', fehler);
            neu.disabled = false;
            neu.addEventListener('click', function () { stand.neuSuchen(); });
            btn.textContent = 'Rücksendung verbindlich anmelden';
            ansage(root, '');
            return;
          }
          sendet = false;
          sperren(false);
          btn.textContent = 'Noch einmal versuchen';
          ansage(root, '');
          zeigeFehler(fehler, fehlerText(code, 'retoure'));
          return;
        }
        /* Ab hier ist die Rücksendung angelegt. Hakt nur die Anzeige, schlicht bestätigen. */
        schritt(root, 4);
        try {
          out.innerHTML = fertigAnsicht(stand, a, r.data);
        } catch (x) {
          out.innerHTML = '<section class="rk-karte rk-karte--erfolg"><h2 class="rk-h2" data-rk-fokus>Ihre Rücksendung ist angemeldet</h2>' +
            '<p class="rk-klein">Rücksendenummer</p><p class="rk-rma">' + esc(r.data.rma) + '</p></section>';
        }
        ansage(root, 'Rücksendung angemeldet.');
        nachOben(root);
        fokus($('[data-rk-fokus]', out));
      });
    });
  }

  /* Nach dem Anmelden: was der Worker entschieden hat (Versandweg, Betrag inkl. erstatteter
     Versandkosten, Rücksendeadresse) – nicht die eigene Rechnung. */
  function fertigAnsicht(stand, a, res) {
    var base = stand.base;
    var hatLabel = !!(beleg(res.labelUrl, base) || beleg(res.qrUrl, base));
    var labelFehlt = (res.method || a.method) === 'label' && !hatLabel;
    var selbst = !hatLabel;
    var betrag = typeof res.refund === 'number' ? res.refund : a.erstattung;
    return '<section class="rk-karte rk-karte--erfolg">' +
      '<span class="rk-erfolg__icon">' + ICON.haken + '</span>' +
      '<h2 class="rk-h2" data-rk-fokus>Ihre Rücksendung ist angemeldet</h2>' +
      '<p class="rk-klein">Rücksendenummer</p>' +
      '<p class="rk-rma">' + esc(res.rma) + '</p>' +
      erstattungsSatz(betrag, Number(res.shippingRefund) || 0) +
      (res.notified ? '<p class="rk-text">Sie bekommen zusätzlich eine Bestätigung per E-Mail.</p>' : '<p class="rk-text">Bitte laden Sie die Unterlagen jetzt herunter.</p>') +
      (labelFehlt ? '<p class="rk-hinweis rk-hinweis--gelb">' + ICON.info + '<span>Das DHL-Label konnte gerade nicht erstellt werden. Bitte frankieren Sie das Paket selbst – eine Labelgebühr ziehen wir dann nicht ab. Oder schreiben Sie uns' + (stand.mail ? ' an ' + esc(stand.mail) : '') + ', dann schicken wir Ihnen das Label nach.</span></p>' : '') +
      '</section>' +
      belege(res, base) +
      (selbst ? '<section class="rk-karte">' + adresseBlock(adresseVon(stand, res)) + '</section>' : '') +
      '<section class="rk-karte"><h3 class="rk-h3">So geht es weiter</h3>' + naechsteSchritte(!selbst, stand.regel.zoll) + '</section>' +
      hilfeKarte(stand.no, stand.mail);
  }

  /* ---------- Benachrichtigen, wenn wieder da (Produktseite) ----------
     Markup: Block rk_notify in templates/product.json (Paket D). Reagiert auf Ereignisse statt per
     setInterval: Variantenwechsel des Themes (pubsub „variant-change“, change am Feld name="id"),
     Zurück-Taste und – als Rückfall für Picker, die nur das value-Attribut setzen – ein
     MutationObserver auf genau diesem Feld. */
  var notifyNr = 0;
  function initNotify(root) {
    var base = root.getAttribute('data-rk-api');
    var daten = {};
    try { daten = JSON.parse($('script[type="application/json"]', root).textContent) || {}; } catch (e) { daten = {}; }
    if (!daten.v) daten.v = {};
    var form = $('form', root);
    var ok = $('[data-rk-ok]', root);
    var fehler = $('[data-rk-fehler]', root);
    if (!form || !ok || !fehler || !form.elements.email) return;
    var bereich = root.closest('product-info') || root.closest('.shopify-section') || document;
    var aktuell = null;
    var sendet = false;
    var okText = ok.innerHTML;
    var input = form.elements.email;

    /* Barrierefreiheit nachrüsten (Markup liegt im Produkt-Template). */
    var nr = ++notifyNr;
    if (!fehler.id) fehler.id = 'rk-notify-fehler-' + nr;
    fehler.setAttribute('role', 'alert');
    ok.setAttribute('tabindex', '-1');
    ok.setAttribute('role', 'status');
    if (!input.getAttribute('inputmode')) input.setAttribute('inputmode', 'email');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');

    function idFeld() {
      var sel = 'form[action*="/cart/add"] [name="id"]';
      return $(sel, bereich) || $(sel);
    }
    function varianteJetzt() {
      var feld = idFeld();
      var id = (feld && feld.value) || new URLSearchParams(location.search).get('variant') || daten.first;
      return String(id || '');
    }
    function pruefen() {
      var id = varianteJetzt();
      if (id === aktuell) return;
      aktuell = id;
      var verfuegbar = Object.prototype.hasOwnProperty.call(daten.v, id) ? daten.v[id] : true;
      root.hidden = verfuegbar !== false;
      ok.hidden = true; form.hidden = false; fehler.hidden = true;
      verknuepfen(input, fehler.id, false);
    }
    var geplant = false;
    function spaeter() {
      if (geplant) return;
      geplant = true;
      setTimeout(function () { geplant = false; pruefen(); }, 30);
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (bereich !== document && !bereich.contains(t)) return;
      if (t.name === 'id' || t.closest('product-variant-selects, variant-selects, variant-radios, .product-form, form[action*="/cart/add"]')) spaeter();
    });
    window.addEventListener('popstate', spaeter);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        /* Der Variantenwechsel bringt den aktuellen Bestand mit – genauer als die Liste beim Seitenaufruf. */
        if (v && v.id != null && typeof v.available === 'boolean') daten.v[String(v.id)] = v.available;
        aktuell = null;
        spaeter();
      });
    }
    var feld = idFeld();
    if (feld && window.MutationObserver) {
      new MutationObserver(spaeter).observe(feld, { attributes: true, attributeFilter: ['value'] });
    }
    pruefen();

    input.addEventListener('input', function () { verknuepfen(input, fehler.id, false); });

    function fehlerZeigen(text) {
      fehler.textContent = text;
      fehler.hidden = false;
      verknuepfen(input, fehler.id, true);
      fokus(input);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sendet) return;
      fehler.hidden = true;
      var email = input.value.trim();
      if (!mailOk(email)) { fehlerZeigen(fehlerText(email ? 'email_bad' : 'email_leer')); return; }
      verknuepfen(input, fehler.id, false);
      var btn = $('button', form);
      var btnText = btn.textContent;
      sendet = true;
      btn.disabled = true; btn.textContent = 'Wird gesendet …';
      holen(api(base, '/api/notify'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ variantId: aktuell, email: email, lang: LANG })
      }, T_HINWEIS).then(function (r) {
        sendet = false;
        btn.disabled = false; btn.textContent = btnText;
        if (!r.ok) {
          fehler.textContent = fehlerText(r.error, 'hinweis');
          fehler.hidden = false;
          if (r.error === 'bad_request') verknuepfen(input, fehler.id, true);
          fokus(fehler);
          return;
        }
        form.hidden = true;
        if (r.data && r.data.available) {
          ok.innerHTML = 'Gute Nachricht: Der Artikel ist gerade wieder lieferbar. ' +
            '<button type="button" class="rk-link rk-link--knopf" data-rk-neu-laden>Seite neu laden</button>';
          $('[data-rk-neu-laden]', ok).addEventListener('click', function () { location.reload(); });
        } else {
          ok.innerHTML = okText;
        }
        ok.hidden = false;
        fokus(ok);
      });
    });
  }

  /* ---------- Widerruf (§ 356a BGB) ----------
     Seite /pages/widerruf, Markup in sections/rk-widerruf.liquid.
     1. Beim Laden: GET /api/health. 404 heißt „alter Worker ohne Widerrufsfunktion“ – dann geht der
        Widerruf gleich über das Kontaktformular, ohne 15 s Wartezeit.
     2. Kunde gibt Name, Bestellnummer, E-Mail (und optional Artikel) an, setzt den Haken und klickt
        „Widerruf bestätigen“. Prüfung im Browser, Meldungen am Feld (aria-describedby).
     3. POST /api/withdrawals → 200 { ok, id, at, until, address, mailed }: Bestätigung mit
        Eingangszeit, Referenz, nächstem Schritt und „Rücksendung anmelden“.
     4. 400 (Angaben abgelehnt): Meldung (role=alert) mit Knopf für den Ersatzweg.
        Alles andere (404, 429, 503, 5xx, Netz, 15 s Zeitlimit): Ersatzweg – das Shopify-
        Kontaktformular geht mit denselben Angaben raus, damit kein Widerruf verloren geht. Nach der
        Rückkehr (?contact_posted=true) zeigt die Seite eine Bestätigung, die keine automatische
        Eingangsbestätigung verspricht. */
  var WD_KEY = 'rk-widerruf';

  function initWiderruf(root) {
    beispielLesen(root);
    var out = $('[data-rk-out]', root);
    var intro = $('[data-rk-intro]', root);
    var form = $('form', root);
    var adresse = String(root.getAttribute('data-rk-adresse') || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
    var base = root.getAttribute('data-rk-api') || '';
    var q = new URLSearchParams(location.search);
    if (!out) return;

    function ruecksendeTeil(d, bis, zeilen) {
      return '<div class="rk-trenner"></div>' +
        '<h3 class="rk-h3">Nächster Schritt: Ware innerhalb von 14 Tagen zurückschicken</h3>' +
        '<p class="rk-text">' + (bis ? 'Bitte senden Sie die Ware bis spätestens <strong>' + esc(bis) + '</strong> zurück. ' : '') +
        'Am einfachsten melden Sie die Rücksendung online an. Ist die Ware noch nicht bei Ihnen, melden Sie die Rücksendung an, sobald sie da ist.</p>' +
        adresseBlock(zeilen) +
        '<div class="rk-knoepfe rk-noprint"><a class="rk-btn" href="' + SEITE_RETOURE + abfrage(d.order, d.email) + '">Rücksendung anmelden</a>' +
        '<button type="button" class="rk-btn rk-btn--hell" data-rk-drucken>Bestätigung drucken oder speichern</button></div>';
    }
    function datenListe(zeilen) {
      return '<dl class="rk-wd-daten">' + zeilen.filter(function (z) { return z[1]; }).map(function (z) {
        return '<div><dt>' + esc(z[0]) + '</dt><dd>' + esc(z[1]) + '</dd></div>';
      }).join('') + '</dl>' +
        '<div class="rk-wd-erklaerung"><span>Ihre Erklärung</span><p>' + esc(ERKLAERUNG) + '</p></div>';
    }
    function anzeigen(html) {
      if (form) form.hidden = true;
      if (intro) intro.hidden = true;
      out.innerHTML = html;
      document.documentElement.classList.add('rk-wd-druck');
      var druck = $('[data-rk-drucken]', out);
      if (druck) druck.addEventListener('click', function () { window.print(); });
      nachOben(root);
      fokus($('[data-rk-fokus]', out));
    }

    /* Bestätigung nach Annahme durch den Worker. Maßgeblich ist sein Eingangsstempel. */
    function bestaetigung(d, res) {
      var am = String(res.at || '');
      if (/^\d{4}-\d{2}-\d{2}T/.test(am) && zeit(am)) am = stempel(zeit(am));
      var zeilen = Array.isArray(res.address) && res.address.length ? res.address : adresse;
      /* mailed:false – gespeichert und dem Shop gemeldet, nur die Mail an den Kunden ging nicht raus. */
      var mailNote = res.mailed === false
        ? '<p class="rk-hinweis rk-hinweis--gelb">' + ICON.info + '<span>Die Eingangsbestätigung per E-Mail konnte gerade nicht verschickt werden. Ihr Widerruf ist trotzdem bei uns eingegangen. ' +
          'Bitte notieren Sie sich die Referenz oder drucken Sie diese Seite. Wir schicken Ihnen die Bestätigung so bald wie möglich per E-Mail.</span></p>'
        : '<p class="rk-text">Wir haben Ihnen eine Eingangsbestätigung an <strong>' + esc(d.email) + '</strong> geschickt.</p>';
      anzeigen('<section class="rk-karte rk-karte--wd rk-wd-beleg">' +
        '<div class="rk-wd-kopf"><span class="rk-erfolg__icon">' + ICON.haken + '</span>' +
        '<h2 class="rk-h2" data-rk-fokus>Ihr Widerruf ist eingegangen</h2></div>' +
        mailNote +
        datenListe([['Eingegangen am', am], ['Referenz', res.id], ['Bestellung', d.order], ['Name', d.name], ['E-Mail-Adresse', d.email], ['Artikel', d.items || 'Gesamte Bestellung']]) +
        ruecksendeTeil(d, res.until, zeilen) +
        '</section>');
    }

    /* Bestätigung nach dem Ersatzweg (Kontaktformular). Ehrlich: keine automatische
       Eingangsbestätigung, Zeit laut Gerät des Kunden. */
    function ersatzBestaetigung(d) {
      var mitDaten = !!(d && d.name);
      anzeigen('<section class="rk-karte rk-karte--wd rk-wd-beleg">' +
        '<div class="rk-wd-kopf"><span class="rk-erfolg__icon">' + ICON.haken + '</span>' +
        '<h2 class="rk-h2" data-rk-fokus>Ihr Widerruf wurde an uns gesendet</h2></div>' +
        '<p class="rk-text">Er ist über unser Kontaktformular bei uns eingegangen. Eine automatische Eingangsbestätigung gibt es auf diesem Weg nicht – wir bestätigen Ihnen den Eingang per E-Mail' +
        (mitDaten ? ' an <strong>' + esc(d.email) + '</strong>' : '') + ', sobald wir die Nachricht bearbeitet haben.</p>' +
        '<p class="rk-hinweis rk-hinweis--gelb">' + ICON.info + '<span>Bitte drucken oder speichern Sie diese Seite als Nachweis, bis unsere Bestätigung da ist.</span></p>' +
        (mitDaten ? datenListe([['Gesendet am (Uhrzeit Ihres Geräts)', d.at], ['Bestellung', d.order], ['Name', d.name], ['E-Mail-Adresse', d.email], ['Artikel', d.items || 'Gesamte Bestellung']]) : '') +
        ruecksendeTeil(mitDaten ? d : {}, '', adresse) +
        '<p class="rk-klein rk-abstand rk-noprint"><a class="rk-link" href="' + SEITE_WIDERRUF + '">Einen weiteren Widerruf erklären</a></p>' +
        '</section>');
    }

    /* Rückkehr vom Ersatzweg: Shopify leitet mit ?contact_posted=true zurück, die Section
       markiert das mit [data-rk-wd-gesendet]. */
    if ($('[data-rk-wd-gesendet]', root) || q.get('contact_posted') === 'true') {
      ersatzBestaetigung(lesen(WD_KEY));
      return;
    }
    if (!form) return;

    var feld = {};
    ['name', 'order', 'email', 'items', 'check', 'at', 'body'].forEach(function (k) { feld[k] = $('[data-f="' + k + '"]', form); });
    var btn = $('button[type=submit]', form);
    var fehler = $('[data-rk-formfehler]', form);
    if (!feld.name || !feld.order || !feld.email || !feld.check || !btn || !fehler) return;
    form.noValidate = true;
    feldBeobachten(form);
    var sendet = false;
    var btnText = btn.textContent;

    /* Kennt der Worker die Widerrufsfunktion? null = unbekannt, true = ja, false = nein (404). */
    var gesund = null;
    if (base) {
      holen(api(base, '/api/health'), {}, T_HEALTH).then(function (r) {
        if (r.ok && r.data && r.data.ok) gesund = true;
        else if (r.status === 404) gesund = false;
      });
    }

    /* Vorbelegen aus der Adresse (?no=&email=) – oder nach einem Fehler des Kontaktformulars aus
       dem gemerkten Stand. */
    if (q.get('no') && !feld.order.value) feld.order.value = q.get('no');
    if (q.get('email') && !feld.email.value) feld.email.value = q.get('email');
    var shopFehler = $('[data-rk-wd-fehler]', root);
    if (shopFehler) {
      var alt = lesen(WD_KEY);
      if (alt) {
        if (!feld.name.value) feld.name.value = alt.name || '';
        if (!feld.order.value) feld.order.value = alt.order || '';
        if (!feld.email.value) feld.email.value = alt.email || '';
        if (feld.items && !feld.items.value) feld.items.value = alt.items || '';
      }
      /* Das Kontaktformular hat abgelehnt (z. B. E-Mail-Adresse): Meldung zeigen und vorlesen. */
      nachOben(shopFehler);
      fokus(shopFehler);
    }

    /* Zurück-Taste nach dem Ersatzweg: Die Seite kommt aus dem Cache mit gesperrtem Knopf. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      form.removeAttribute('data-rk-nativ');
      sendet = false;
      btn.disabled = false;
      btn.textContent = btnText;
    });

    function falsch(code, el) {
      zeigeFehler(fehler, fehlerText(code), '', [el]);
      return null;
    }
    /* Angaben lesen und prüfen. Gibt die Daten zurück oder null (Meldung steht dann am Feld). */
    function sammeln() {
      var d = {
        name: feld.name.value.replace(/\s+/g, ' ').trim(),
        order: bestellNr(feld.order.value) || feld.order.value.trim(),
        email: feld.email.value.trim(),
        items: feld.items ? feld.items.value.trim() : ''
      };
      if (!d.name) return falsch('wd_name', feld.name);
      if (!d.order) return falsch('wd_order', feld.order);
      if (!d.email) return falsch('wd_email', feld.email);
      if (!mailOk(d.email)) return falsch('email_bad', feld.email);
      if (!feld.check.checked) return falsch('wd_check', feld.check);
      var jetzt = new Date();
      d.at = stempel(jetzt);
      d.iso = jetzt.toISOString();
      return d;
    }
    function sperren() {
      sendet = true;
      btn.disabled = true;
      btn.textContent = 'Wird gesendet …';
    }
    function freigeben() {
      sendet = false;
      btn.disabled = false;
      btn.textContent = btnText;
    }

    /* Ersatzweg: alles, was ins Shop-Postfach muss, steht im Nachrichtentext. */
    function ersatzweg(d, grund) {
      merken(WD_KEY, d);
      if (feld.at) feld.at.value = d.at + ' (' + d.iso + ')';
      if (feld.body) {
        feld.body.value =
          'WIDERRUF nach § 356a BGB – über das Kontaktformular (Ersatzweg)\n' +
          'Abgeschickt (Uhr des Kunden): ' + d.at + ' (' + d.iso + ')\n' +
          'Name: ' + d.name + '\n' +
          'Bestellnummer: ' + d.order + '\n' +
          'E-Mail: ' + d.email + '\n' +
          'Artikel: ' + (d.items || 'Gesamte Bestellung') + '\n\n' +
          'Erklärung: ' + ERKLAERUNG + '\n\n' +
          'Grund für den Ersatzweg: ' + grund + '\n\n' +
          'WICHTIG: Der Kunde hat noch KEINE Eingangsbestätigung. Bitte unverzüglich per E-Mail bestätigen – mit dem Inhalt der Erklärung sowie Datum und Uhrzeit des Eingangs.';
      }
      ansage(root, 'Ihr Widerruf wird gesendet.');
      form.setAttribute('data-rk-nativ', '1');
      HTMLFormElement.prototype.submit.call(form);
    }

    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-rk-nativ') === '1') return;
      e.preventDefault();
      if (sendet) return;
      fehlerWeg(fehler);
      var d = sammeln();
      if (!d) return;
      merken(WD_KEY, d);
      sperren();
      ansage(root, 'Ihr Widerruf wird gesendet.');

      if (!base) { ersatzweg(d, 'keine Worker-Adresse'); return; }
      if (gesund === false) { ersatzweg(d, 'Worker ohne Widerrufsfunktion (/api/health 404)'); return; }

      holen(api(base, '/api/withdrawals'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: d.name, order: d.order, email: d.email, items: d.items, lang: LANG })
      }, T_WIDERRUF).then(function (r) {
        if (r.ok && r.data && r.data.ok) {
          ansage(root, 'Ihr Widerruf ist eingegangen.');
          try { sessionStorage.removeItem(WD_KEY); } catch (x) {}
          try {
            bestaetigung(d, r.data);
          } catch (x) {
            /* Angenommen ist er – hakt nur die Anzeige, schlicht bestätigen. */
            anzeigen('<section class="rk-karte rk-karte--wd rk-wd-beleg"><h2 class="rk-h2" data-rk-fokus>Ihr Widerruf ist eingegangen</h2>' +
              '<p class="rk-text">Referenz ' + esc(r.data.id || '') + (r.data.at ? ' · eingegangen am ' + esc(r.data.at) : '') + '</p></section>');
          }
          return;
        }
        if (r.status === 400) {
          /* Angaben abgelehnt: Kunde kann korrigieren – oder gleich den Ersatzweg nehmen. */
          freigeben();
          ansage(root, '');
          zeigeFehler(fehler, fehlerText('wd_abgelehnt'),
            '<button type="button" class="rk-btn rk-btn--hell rk-btn--klein" data-rk-ersatz>Über das Kontaktformular senden</button>');
          $('[data-rk-ersatz]', fehler).addEventListener('click', function () {
            if (sendet) return;
            var d2 = sammeln();
            if (!d2) return;
            sperren();
            ersatzweg(d2, 'Worker 400 bad_request – Kunde hat den Ersatzweg gewählt');
          });
          return;
        }
        ersatzweg(d, 'Worker ' + (r.status || '') + ' ' + (r.error || 'ohne Antwort'));
      });
    });
  }

  /* ---------- Start ---------- */
  function einmal(fn) {
    return function (el) {
      if (el.getAttribute('data-rk-init')) return;
      el.setAttribute('data-rk-init', '1');
      try { fn(el); } catch (e) { if (window.console) console.error('rk-portal', e); }
    };
  }
  function start(scope) {
    var r = scope && scope.querySelectorAll ? scope : document;
    $$('[data-rk-track]', r).forEach(einmal(initTrack));
    $$('[data-rk-return]', r).forEach(einmal(initReturn));
    $$('[data-rk-widerruf]', r).forEach(einmal(initWiderruf));
    $$('[data-rk-notify]', r).forEach(einmal(initNotify));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); });
  else start();
  /* Theme-Editor: neu geladene Abschnitte starten */
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
